import React, { useRef } from 'react';
import useOutsideAlert from './useOutsideAlert';

interface ContextMenuProps {
    x: number,
    y: number,
    closeConextMenu: () => void,
    children: React.ReactNode,
    className: string,
};

export const ContextMenu = ({ x, y, closeConextMenu, children, className = ''}: ContextMenuProps) => {

    const ContextMenuRef = useRef<HTMLDivElement>(null);
    useOutsideAlert(ContextMenuRef, closeConextMenu);
    return (
        <div
            className={`${className}`}
            ref={ContextMenuRef}
            style={{top: `${y}px`, left: `${x}px`, position: 'absolute'}}
        >
            {children}
        </div>
    )
};

export default ContextMenu;